const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

const normalizeApiUrl = (value) => {
  const raw = trimTrailingSlash(value || '');
  if (!raw) {
    if (import.meta.env.PROD) {
      return 'https://api.hebrewhearts.com/api/v1';
    }
    throw new Error('VITE_API_URL is not set. Configure web/.env for development.');
  }
  if (raw.endsWith('/api/v1')) return raw;
  if (raw.endsWith('/api')) return `${raw}/v1`;
  return `${raw}/api/v1`;
};

export const API_BASE_URL = normalizeApiUrl(import.meta.env.VITE_API_URL);
export const API_ORIGIN = API_BASE_URL.replace(/\/api\/v1$/, '');

export const SOCKET_URL = trimTrailingSlash(
  import.meta.env.VITE_SOCKET_URL || API_ORIGIN
);

export const MESSAGING_SERVICE_URL = trimTrailingSlash(
  import.meta.env.VITE_MESSAGING_SERVICE_URL ||
    (import.meta.env.DEV ? 'http://localhost:3005' : 'https://messaging.hebrewhearts.com')
);

export const OAUTH_CLIENT_IDS = {
  google: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
  apple: import.meta.env.VITE_APPLE_CLIENT_ID || '',
  facebook: import.meta.env.VITE_FACEBOOK_APP_ID || '',
};
